// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6KsII","colBig":"styles_colBig__fbsl5","colSmall":"styles_colSmall__2wJZc"};